module.exports = __webpack_public_path__ + "static/peppers-museum-e7b0fa69f1144231d85458f0fb175141.jpg";